import {
    useState,
    useEffect,
    useRef,
} from 'react';
import axios from 'axios';
import { Auth } from 'aws-amplify';
import { API, graphqlOperation } from 'aws-amplify';

import { secrets } from './secrets';
import { formatTimeToDate } from './utils'
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';

export function useTopHeadlines(query) {
    const [articles, updateArticles] = useState([]);
    const [loading, updateLoading] = useState(false);
    useEffect(() => {
        let params;
        if (query.source && query.source.length > 0) {
            params = Object.assign(
                {},
                { sources: query.source.join(',') },
            );
        } else if (query.country || query.category || query.search) {
            params = Object.assign(
                {},
                query.country && {country: query.country},
                query.category && {category: query.category},
                query.search && {q: query.search},
            );
        } else {
            return;
        }

        updateLoading(true);
        params.pageSize = 60;
        const config = {
            params,
        }
        axios
            .get(secrets.topHeadlinesUrl, config)
            .then(response => {
                updateArticles(response.data.articles);
                updateLoading(false);
            })
            .catch(error => {
                console.error(error);
                updateLoading(false);
            })
    }, [query, updateLoading, updateArticles]);
    return [articles, loading, updateArticles];
}

export function useEverything(query) {
    const [articles, updateArticles] = useState([]);
    const [loading, updateLoading] = useState(false);
    useEffect(() => {
        let params;
        if (query.source && query.source.length > 0) {
            params = Object.assign(
                {},
                { sources: query.source.join(',') },
                query.sortBy && {sortBy: query.sortBy},
                query.from && {from: formatTimeToDate(query.from)},
                query.to && {to: formatTimeToDate(query.to)},
            );
        } else if (query.language || query.from || query.to || query.search || query.searchInTitle) {
            params = Object.assign(
                {},
                query.language && {language: query.language},
                query.from && {from: formatTimeToDate(query.from)},
                query.to && {to: formatTimeToDate(query.to)},
                query.search && {q: query.search},
                query.searchInTitle && {qInTitle: query.searchInTitle},
                query.sortBy && {sortBy: query.sortBy},
            );
        } else {
            return;
        }

        updateLoading(true);
        params.pageSize = 60;
        const config = {
            params,
        }
        axios
            .get(secrets.everythingUrl, config)
            .then(response => {
                updateArticles(response.data.articles);
                updateLoading(false);
            })
            .catch(error => {
                console.error('fetching error', error);
                updateLoading(false);
            })
    }, [query, updateLoading, updateArticles]);
    return [articles, loading, updateArticles];
}

export function useUserBookmarks() {
    const [bookmarks, setBookmarks] = useState([]);

    useEffect(() => {
        Auth.currentAuthenticatedUser({ bypassCache: false, })
            .then(user => {
                const userId = user.attributes.sub;
                API.graphql(graphqlOperation(queries.listBookmarks, { userId }))
                    .then(result => {
                        setBookmarks(result.data.listBookmarks.items);
                    })
                    .catch(err => console.error(err));
            })
            .catch(err => console.error(err));
    }, [setBookmarks]);
    return bookmarks;
}

export function deleteBookmark(id) {
    API.graphql(graphqlOperation(mutations.deleteBookmark, { input: { id } }));
}

export function createBookmark(query) {
    Auth.currentAuthenticatedUser({ bypassCache: false, })
        .then(user => {
            const userId = user.attributes.sub;
            const bookmark = {
                ...query,
                userId,
                createAt: new Date(),
            };
            API.graphql(graphqlOperation(mutations.createBookmark, { input: bookmark }))
        })
        .catch(err => console.error(err));
}

export function usePrevious(value) {
    const ref = useRef();

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
}
